module.exports = __webpack_public_path__ + "img/icon2.e82775d8.png";